import { useContext, useLayoutEffect } from 'react';
import { SiteThemeContext, useThemePreference, applySiteTheme } from 'components/SiteTheme';
export { THEME_KEY, THEME_OPTIONS, initialPreference } from 'components/SiteTheme';

// The page attribute owns Paperwork scrolling only; color preference belongs to the app.
export default function usePaperworkTheme(scope = 'paperwork') {
  const shared = useContext(SiteThemeContext);
  const fallback = useThemePreference(!shared);
  const state = shared || fallback;
  useLayoutEffect(() => {
    if (!shared) applySiteTheme(state.theme);
    const attribute = scope === 'services' ? 'servicesTheme' : 'paperworkTheme';
    document.documentElement.dataset[attribute] = state.theme;
    return () => { delete document.documentElement.dataset[attribute]; };
  }, [state.theme, scope, shared]);
  return state;
}
